





































































































import Vue from "vue";
import {
  LogLevels,
  RoomDetail,
  RoomOverallStateData,
  RoomOverallStatesData,
} from "@/models/room";
import VaInfoRow from "@/components/molecules/VaInfoRow.vue";
import VaChip from "@/components/atoms/VaChip.vue";
import i18n from "@/i18n";

export default Vue.extend({
  name: "RoomInformationAndroid",
  components: { VaChip, VaInfoRow },
  methods: {
    // getLoglevel(n: number): string {
    //   const res = LogLevels[n];
    //   return i18n.t(`validate.${res}`) as string;
    // },
  },
  computed: {
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
    loglevel(): string {
      const number = this.room.machineLogConfiguration as number;
      const res = LogLevels[number];
      return i18n.t(`roomCommands.${res}`) as string;
    },

    isAndroid(): boolean {
      return this.room?.deviceType === "AndroidReceiver";
    },
    peopleCountValue() {
      const room = this.$store.getters["room/room"];
      if (
        !room.online ||
        !room.roomCapacity ||
        (room.roomCapacity && room.roomCapacity.peopleCountValue === undefined)
      ) {
        return this.$t("common.n/a");
      } else {
        return room.roomCapacity?.peopleCountValue?.toString();
      }
    },
    overallStateData(): RoomOverallStateData {
      const room = this.$store.getters["room/room"];
      return RoomOverallStatesData.find((overallState) => {
        return overallState.id === room.overallState;
      }) as RoomOverallStateData;
    },
    overallPerformanceStatusData(): any {
      return {
        color: "",
        label: "",
      };
      /*return PerformanceUtil.overallStatusData(
        this.rooms.performance as RoomPerformance
      );*/
    },
  },
});
